import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Sticky from 'react-sticky-el';

const MatchingHeader = createReactClass({
    propTypes: {
        matchingFund: PropTypes.object.isRequired,

        isMobile: PropTypes.bool,
    },

    render: function () {
        const props = this.props;
        const matchingFund = props.matchingFund;
        const matchingText = matchingFund.description
            .replace('this project', 'these projects')
            .replace(/<p><a.+$/, ''); // Strip link to the search page since we're already there

        // If this is an umbrella/parent match, we don't want to show the multiplier
        // since it can vary among the child matches
        let matchingBadge;
        if (!matchingFund.isParent) {
            const multiplier = this.props.matchingFund.multipleForDisplay;
            const matchTypeClass = matchingFund.multipleForDisplay === '1.5X'
                ? 'match-offer-badge onepointfive' : 'match-offer-badge dyi';
            matchingBadge = (
                <div className="match-offer-badge-container">
                    <div className={matchTypeClass}><span className="match-offer-badge-content">{multiplier}</span>
                    </div>
                </div>
            );
        }

        let matchingDescription = (
            <div className="matching-description">
                {matchingBadge}
                <div dangerouslySetInnerHTML={{ __html: matchingText }}></div>
            </div>
        );

        // The sticky description would take up too much room on mobile
        if (!props.isMobile) {
            matchingDescription = (
                <div>
                    <Sticky stickyClassName="fixed partner-information">
                        {matchingDescription}
                    </Sticky>
                </div>
            );
        }

        return matchingDescription;
    },
});

export default MatchingHeader;
